import styled from "styled-components"
import { PreviewWatermark } from "./PreviewWatermark"

const Container = styled.div<{ $lastPage?: boolean }>`
	margin: 0 16mm;
	break-after: ${(props) => (props.$lastPage ? "avoid" : "page")};
	line-height: 18pt;
	font-size: 12pt;
	font-weight: 300;
	position: relative;
`

interface PageProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * CSS named-page value for paged.js. When set, paged.js applies the
   * matching @page <name> rule to this element's pages. For example,
   * named="frontpage" matches @page frontpage { ... } which can suppress
   * the footer via @bottom-left { content: none }.
   */
  named?: string
  /**
   * When true, sets break-after to "avoid" instead of "page" to prevent
   * paged.js from creating a trailing blank page after the last section.
   */
  lastPage?: boolean
  children: React.ReactNode
}

export const Page = ({ children, named, lastPage, ...rest }: PageProps) => {
  return (
    <Container $lastPage={lastPage} data-page={named} {...rest}>
      <PreviewWatermark />
      {children}
    </Container>
  )
}
